import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-title roboto-slab" }
const _hoisted_2 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["menu-button flex", { "router-link-active": _ctx.isActive }]),
    type: "button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)))
  }, [
    _createElementVNode("i", {
      class: _normalizeClass(["mr", _ctx.menuItem.icon])
    }, null, 2),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        textContent: _toDisplayString(_ctx.$t(_ctx.menuItem.title))
      }, null, 8, _hoisted_2),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "dot ml-05" }, ".", -1))
    ])
  ], 2))
}